<template>
  <div id="container" class="block h-screen lg:flex lg:flex-1 lg:pb-24 lg:pr-32 lg:pl-32 lg:pt-24">
    <div class="flex flex-row w-full h-full mx-auto my-auto shadow-xl wrapper bg-background">
      <div id="sidebar" class="hidden w-64 overflow-y-auto text-sm transition duration-300 ease-in border-r border-background-menu text-letter-profile lg:flex lg:flex-col bg-primary">
        <Profile />
        <div class="w-full p-2 border-t cursor-pointer border-letter-profile bg-primary group">
          <div class="text-center group-hover:text-tertiary">
            <a class="block w-full h-full" href="https://drive.google.com/file/d/0B8IW66bnAqxyTWRYN01kTnVDYm8/view" target="_blank">
              Descargar CV
            </a>
          </div>
        </div>
      </div>
      <div id="content-area" class="box-border flex flex-col flex-1 overflow-x-hidden overflow-y-auto transition duration-300 ease-in bg-background text-secondary">
        <div v-show="sidebarOpen" class="z-20 lg:hidden">
          <transition
            enter-class="-translate-x-full"
            enter-to-class="translate-x-0"
            leave-class="translate-x-0"
            leave-to-class="-translate-x-full"
          >
            <div @click="sidebarOpen = false" v-show="sidebarOpen" class="fixed inset-0 z-30">
              <div class="absolute inset-0 bg-gray-600 opacity-75"></div>
            </div>
          </transition>
          <div class="fixed inset-0 z-40 flex w-full">
            <transition
              enter-class="-translate-x-full"
              enter-to-class="translate-x-0"
              leave-class="translate-x-0"
              leave-to-class="-translate-x-full"
            >
              <div
                v-show="sidebarOpen"
                class="flex flex-col flex-1 w-full max-w-xs duration-300 ease-in-out transform bg-gray-800"
              >
                <div class="absolute top-0 right-0 z-50 p-1">
                  <button
                    v-show="sidebarOpen"
                    @click="sidebarOpen = false"
                    class="flex items-center justify-center w-12 h-12 rounded-full focus:outline-none focus:bg-gray-600"
                  >
                    <svg
                      class="w-6 h-6 text-quaternary"
                      stroke="currentColor"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
                  <Profile class="h-full text-letter-profile bg-primary"/>
                  <div class="w-full p-2 border-t cursor-pointer border-letter-profile bg-primary group">
                    <div class="text-center group-hover:text-tertiary">
                      <a class="block w-full h-full text-white" href="https://drive.google.com/file/d/0B8IW66bnAqxyTWRYN01kTnVDYm8/view" target="_blank">
                        Descargar CV
                      </a>
                    </div>
                  </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="flex justify-between p-4 lg:hidden">
          <button
            @click.stop="sidebarOpen = true"
            class="z-10 text-secondary focus:outline-none focus:text-tertiary"
          >
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </button>
          <button
            @click.stop="openMenu"
            class="z-10 text-secondary focus:outline-none focus:text-tertiary"
          >
            <svg class="w-6 h-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h7"
              />
            </svg>
          </button>
        </div>
        <transition 
          enter-class="fade-enter"
          enter-to-class="fade-enter-active"
          leave-class="fade-leave-active"
          leave-to-class="fade-leave-to"
          mode="out-in">
            <router-view />
        </transition>
      </div>
      <div
        id="menu"
        class="flex flex-col justify-between hidden w-16 h-full pt-4 pb-4 overflow-y-auto transition duration-300 ease-in border-l bg-background lg:flex"
      >
          <Menu/>
          <SocialMenu />
      </div>
    </div>
  </div>
</template>

<script>
import Profile from "./components/Profile.vue";
import SocialMenu from "./components/SocialMenu.vue";
import Menu from "./components/Menu.vue";

export default {
  components: {
    Profile,
    SocialMenu,
    Menu
  },
  data() {
    return {
      sidebarOpen: false,
      menuOpen: false
    };
  },
  methods: {
    openMenu() {
      let menu = document.getElementById("menu");
      if (this.menuOpen) {
        menu.classList.add("hidden");
        menu.classList.remove("flex");
      } else {
        menu.classList.remove("hidden");
        menu.classList.add("flex");
      }
      this.menuOpen = !this.menuOpen;
    },
    cerrarMenu() {
      this.menuOpen = false;
    }
  },
};
</script>

<style></style>
